import "intersection-observer/intersection-observer";
import Vuex from "vuex";
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vee-validate";
import "./plugins/fragment";
import "./plugins/wysiwyg";
import "./plugins/observe-visibility";
import "./plugins/timers";
import "./plugins/viewer";
import "./plugins/mq";
import App from "./App.vue";
import router from "./router";
import moment from "moment";

import "./global.style.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuex);

Vue.config.productionTip = false;

Vue.filter("date", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM/YYYY");
  }
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("fullDate", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM/YYYY à HH:mm");
  }
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY à HH:mm");
  }
});

Vue.filter("shortDate", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("DD/MM");
  }
  if (value) {
    return moment(String(value)).format("DD/MM");
  }
});

Vue.filter("monthYear", function(value) {
  if (typeof value === "number") {
    return moment.unix(value / 1000).format("MM/YYYY");
  }
  if (value) {
    return moment(String(value)).format("MM/YYYY");
  }
});

Vue.filter("time", function(value) {
  if (!value) {
    return "??";
  }
  const mins = (value / 60).toFixed(0);
  const minsLeft = mins % 60;
  const hours = Math.floor(mins / 60);
  if (hours >= 2) {
    return `${Math.floor(mins / 60)}h${minsLeft < 10 ? "0" : ""}${minsLeft}`;
  } else {
    return `${mins < 10 ? "0" : ""}${mins}min`;
  }
});

const app = new Vue({
  store: require("./stores/index").default,
  router,
  render: h => h(App)
});

app.$mount("#app");
